import { createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { TooltipProvider } from "./components/ui/tooltip";
import { AuthProvider } from "./context/auth-provider";
import { GraphqlProvider } from "./context/graphql-provider";
import { RouterProvider } from "./context/router-provider";
import { ThemeProvider } from "./context/theme-provider";
import "./index.css";
import { routeTree } from "./routeTree.gen";

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
    urqlClient: undefined!,
  },
});

const rootElement = document.getElementById("root")!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <AuthProvider router={router}>
        <GraphqlProvider router={router}>
          <ThemeProvider>
            <TooltipProvider>
              <RouterProvider router={router} />
            </TooltipProvider>
          </ThemeProvider>
        </GraphqlProvider>
      </AuthProvider>
    </StrictMode>,
  );
}
